<template>
  <div class="full-screen-select">
    <popup ref="popup"
      :fullScreen="true"
      :visible="true"
      :title="title"
      :style="{'z-index': zIndex}"
      :showChoose="false"
      @confirm="() => {}">
      <div class="panel-wrap">
        <VisitObjectList
          :options="options"
          @back="back"
          @confirm="confirm"
        />
      </div>
    </popup>
  </div>
</template>

<script type="text/ecmascript-6">
// TODO:showChoose 先写死
import Popup from '@/components/Popup'
import { i18n } from '@/common/utils/i18n'
import VisitObjectList from '../VisitObjectList/index.vue'

export default {
  name: 'VisitObjectListPopup',
  components: {
    Popup,
    VisitObjectList
  },
  props: {
    title: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    zIndex: {
      required: false,
      type: Number,
      default: 50
    },
    options: {}
  },
  methods: {
    back () {
      this.$emit('back')
      this.$refs.popup.cancel()
    },
    confirm (data) {
      this.$emit('confirm', data)
      this.$refs.popup.cancel()
    },
    show () {
      this.$refs.popup.show()
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen-select {
  overflow: auto;
  &-btn {
    // padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }
  ::v-deep .rich-btn-outline:after {
    border: none;
  }
  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }
}
@media only screen and (min-width: 800px) {
  .full-screen-select {
    .popup {
      width: 600Px;
      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }
}
</style>
